import { useState } from "react";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { INTERNAL_PATHS } from "routes/paths";
import { useNavigate } from "hooks/useCustomNavigation";
import { setDisplayNotification } from "services/storage";
import { sendResetInstructions } from "./requests";
import { FEEDBACK_MESSAGES } from "./constants";

export const useHandleResetEmailSubmit = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification, addPersistedNotification } = useShowSnackbar();
  const navigate = useNavigate();

  const handleSendResetInstructions = async ({ email }) => {
    setIsLoading(true);
    try {
      await sendResetInstructions({ email });
      setDisplayNotification();
      addPersistedNotification({
        message: FEEDBACK_MESSAGES.success,
        variant: "success",
        persist: true
      });
      navigate(INTERNAL_PATHS.USER_LOG_IN);
    } catch (error) {
      addNotification({
        message: FEEDBACK_MESSAGES.error,
        variant: "error",
        persist: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSendResetInstructions
  };
};
